import React from 'react';
import { Svg } from 'components/icons/Svg';

export const IconArrowLeft = props => (
  <Svg {...props}>
    <path
      d="M15 6l-6 6 6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
